import { rem } from 'polished'
import styled from 'styled-components'

import PlaceholderBox from './PlaceholderBox'

import { mediaQueryUp } from 'components/utils/breakpoint'
import { DetailCardAndPinLayout, DetailCardLayout } from '../DetailItemCard/common/DetailCardAndPinLayout'
import LoadingBox from 'components/Common/Loading/LoadingBox'

const ImagePlaceholder = styled(LoadingBox)`
  width: 100%;
  aspect-ratio: 1 / 1;
`

const TextPlaceholderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(8)};
`

const TextPlaceholder = styled(PlaceholderBox)`
  height: ${rem(16)};

  ${mediaQueryUp.tablet} {
    height: ${rem(18)};
  }
`

function ItemCardSkeleton() {
  return (
    <DetailCardAndPinLayout>
      <DetailCardAndPinLayout.Pin className="pin-anchor">
        <LoadingBox style={{ width: '20px', height: '20px', borderRadius: '50%' }} />
      </DetailCardAndPinLayout.Pin>
      <DetailCardAndPinLayout.CardContainer>
        <DetailCardLayout.Image>
          <ImagePlaceholder />
        </DetailCardLayout.Image>
        <DetailCardLayout.Content>
          <TextPlaceholderWrapper>
            <TextPlaceholder style={{ width: '100%' }} />
            <TextPlaceholder style={{ width: '33%' }} />
          </TextPlaceholderWrapper>
        </DetailCardLayout.Content>
      </DetailCardAndPinLayout.CardContainer>
    </DetailCardAndPinLayout>
  )
}

export default ItemCardSkeleton
